import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Clapperboard, LogOut, Film } from "lucide-react";

const nav = [
  { to: "/dashboard", label: "Painel", icon: LayoutDashboard },
  { to: "/projects", label: "Projetos", icon: Clapperboard },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex bg-[#08080C]">
      <div className="grain" />
      <aside className="w-64 shrink-0 border-r border-[#282834] bg-[#08080C] flex flex-col fixed h-screen z-20">
        <div className="px-6 py-6 flex items-center gap-3 border-b border-[#282834]">
          <div className="w-9 h-9 rounded-lg bg-[#FF2E93] flex items-center justify-center">
            <Film className="w-5 h-5 text-white" />
          </div>
          <div>
            <p className="font-head font-700 text-[15px] leading-tight text-[#F4F4F5]">Reality<span className="text-[#FF2E93]">Editor</span></p>
            <p className="text-[10px] uppercase tracking-widest text-[#A1A1AA]">Studio</p>
          </div>
        </div>

        <nav className="flex-1 px-3 py-5 space-y-1">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors duration-200 ${
                  isActive
                    ? "bg-[#1C1C24] text-[#F4F4F5] border-l-2 border-[#FF2E93]"
                    : "text-[#A1A1AA] hover:bg-[#121218] hover:text-[#F4F4F5]"
                }`
              }
            >
              <n.icon className="w-[18px] h-[18px]" />
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="px-4 py-4 border-t border-[#282834]">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-9 h-9 rounded-full bg-[#1C1C24] border border-[#282834] flex items-center justify-center text-sm font-semibold text-[#00E5FF]">
              {(user?.name || "U").charAt(0).toUpperCase()}
            </div>
            <div className="min-w-0">
              <p className="text-sm text-[#F4F4F5] truncate" data-testid="current-user-name">{user?.name}</p>
              <p className="text-[10px] uppercase tracking-wider text-[#A1A1AA]">
                {user?.role === "producer" ? "Produtor" : "Editor"}
              </p>
            </div>
          </div>
          <button
            onClick={doLogout}
            data-testid="logout-button"
            className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-[#A1A1AA] hover:bg-[#1C1C24] hover:text-[#FF2E93] transition-colors duration-200"
          >
            <LogOut className="w-4 h-4" /> Sair
          </button>
        </div>
      </aside>

      <main className="flex-1 ml-64 relative z-10">{children}</main>
    </div>
  );
}
